// extracted by mini-css-extract-plugin
export default {"table":"WirelessTab_table__C14GD"};